export enum BeneficiaryRelationshipEnum {
    Unspecified = "Unspecified",
    Spouse = "Spouse",
    Child = "Child",
    Sibling = "Sibling",
    Parent = "Parent",
    Grandchild = "Grandchild",
    OtherRelative = "Other relative",
}